import React from "react";

const Ingreso = React.lazy(() => import("./Pages/Ingreso/Index"));
const Registro = React.lazy(() => import("./Pages/Registro/Index"));
const Perfil = React.lazy(() => import("./Pages/Dashboard/Perfil"));
const Dashboard = React.lazy(() => import("./Pages/Dashboard/Index"));
const AdminHome = React.lazy(() => import("./Pages/Dashboard/AdminHome"));

//OPCIONES PARA MÒDULO ADMINISTRADOR
const Segmento = React.lazy(() =>
  import("./Pages/Dashboard/Administrador/Segmentos/Index")
);
const Distribucion = React.lazy(() =>
  import("./Pages/Dashboard/Administrador/Usuarios/Distribucion/Index")
);
const Rol = React.lazy(() =>
  import("./Pages/Dashboard/Administrador/Usuarios/Roles/Index")
);
const Usuarios = React.lazy(() =>
  import("./Pages/Dashboard/Administrador//Usuarios/Usuarios/Index")
);
const Permisos = React.lazy(() =>
  import("./Pages/Dashboard/Administrador/Usuarios/Roles/Permisos/Index")
);
const Idiomas = React.lazy(() =>
  import("./Pages/Dashboard/Administrador/Idiomas/Index")
);
const Pilares = React.lazy(() =>
  import("./Pages/Dashboard/Administrador/Cursos/Pilares/Index")
);
const Cursos = React.lazy(() =>
  import("./Pages/Dashboard/Administrador/Cursos/Cursos/Index")
);
const Subpilares = React.lazy(() =>
  import("./Pages/Dashboard/Administrador/Cursos/Subpilares/Index")
);
const PalabrasClave = React.lazy(() =>
  import("./Pages/Dashboard/Administrador/Cursos/Etiquetas/Index")
);
const Niveles = React.lazy(() =>
  import("./Pages/Dashboard/Administrador/Niveles/Index")
);
const Contenido = React.lazy(() =>
  import("./Pages/Dashboard/Administrador/Cursos/Contenido/Index")
);
const ContenidoHijo = React.lazy(() =>
  import("./Pages/Dashboard/Administrador/Cursos/ContenidoHijo/Index")
);
const Delegaciones = React.lazy(() =>
  import("./Pages/Dashboard/Administrador/Usuarios/Delegaciones/Index")
);
const Opciones = React.lazy(() =>
  import("./Pages/Dashboard/Administrador/Opciones/Index")
);
const Dificultad = React.lazy(() =>
  import("./Pages/Dashboard/Administrador/Dificultad/Index")
);
const TiposAprendizaje = React.lazy(() =>
  import("./Pages/Dashboard/Administrador/TipoAprendizaje/Index")
);
const PaquetesCursos = React.lazy(() =>
  import("./Pages/Dashboard/Administrador/Cursos/Paquetes/Index")
);
const Tutorial = React.lazy(() =>
  import("./Pages/Dashboard/Administrador/Tutorial/Index")
);
const NotificacionesPlantillas = React.lazy(() =>
  import("./Pages/Dashboard/Administrador/NotificacionesPlantillas/Index")
);
const NotificacionesLista = React.lazy(() =>
  import("./Pages/Dashboard/Administrador/NotificacionesLista/Index")
);
const ReferidosLista = React.lazy(() =>
  import("./Pages/Dashboard/Administrador/ReferidosLista/Index")
);
const AtencionCliente = React.lazy(() =>
  import("./Pages/Dashboard/Administrador/AtencionCliente/Index")
);
const CursosCliente = React.lazy(() =>
  import("./Pages/Dashboard/Administrador/AtencionCliente/CursosCliente/Index")
);
const PaquetesCliente = React.lazy(() =>
  import(
    "./Pages/Dashboard/Administrador/AtencionCliente/PaquetesCliente/Index"
  )
);

//OPCIONES PARA MÒDULO DE ASISTENTE
const SalaCapacitacion = React.lazy(() =>
  import("./Pages/Dashboard/Asistente/SalaCapacitacion/Index")
);
const ReporteCapacitaciones = React.lazy(() =>
  import("./Pages/Dashboard/Reporteria/ReporteCapacitaciones")
);
const ReporteSatisfaccion = React.lazy(() =>
  import("./Pages/Dashboard/Reporteria/ReporteSatisfaccion")
);
const RegistroParticipantes = React.lazy(() =>
  import(
    "./Pages/Dashboard/Asistente/SalaCapacitacion/RegistroParticipantes/Index"
  )
);
const ListadoCapacitaciones = React.lazy(() =>
  import("./Pages/Dashboard/Asistente/Capacitaciones/Index")
);
const CasosEspeciales = React.lazy(() =>
  import("./Pages/CasosEspeciales/Index")
);
const ListadoCasos = React.lazy(() =>
  import("./Pages/CasosEspeciales/Asistente/List")
);
const DetalleCaso = React.lazy(() =>
  import("./Pages/CasosEspeciales/Asistente/Detalle")
);
const CasosForm = React.lazy(() => import("./Forms/CasosEspeciales/Index"));
const DetalleActa = React.lazy(() =>
  import("./Pages/Dashboard/Reporteria/DetalleActa")
);
const ReporteAjustes = React.lazy(() =>
  import("./Pages/Dashboard/Reporteria/ReporteAjustes")
);

//MÓDULO DE CONFIGURACIOENS
const Configuracion = React.lazy(() =>
  import("./Pages/Dashboard/Administrador/Configuracion/Index")
);

//VISTA DE CLIENTES
const Clientes = React.lazy(() => import("./Pages/Dashboard/Cliente/Index"));

//MÓDULO DE WHATSAPP EDUCATIVO
const SegmentosEducativos = React.lazy(() => import('./Pages/Dashboard/WhatsApp/SegmentoEducativo/Index'));
const Productos = React.lazy(() => import('./Pages/Dashboard/WhatsApp/Productos/Index'));
const Microaprendizaje = React.lazy(() => import('./Pages/Dashboard/WhatsApp/Microaprendizajes/Index'));
const ContenidoMicroaprendizaje = React.lazy(() => import('./Pages/Dashboard/WhatsApp/Microaprendizajes/Contenido/Index.jsx'));
const Estructura = React.lazy(() => import('./Pages/Dashboard/WhatsApp/Estrucutas/Index'));
const Encuesta = React.lazy(() => import('./Pages/Dashboard/WhatsApp/Encuestas/Index'));
const Preguntas = React.lazy(() => import('./Pages/Dashboard/WhatsApp/Encuestas/Preguntas/Index'));
const Campania = React.lazy(() => import('./Pages/Dashboard/WhatsApp/Campanias/Index'));
const AgregarCampania = React.lazy(() => import('./Forms/WhatsAppEducativo/Campania/Index'));
const HorarioCampanias = React.lazy(() => import('./Pages/Dashboard/WhatsApp/Campanias/Horario/Index'));
const ReportesWhatsApp = React.lazy(() => import('./Pages/Dashboard/WhatsApp/Reporteria/Index'));
const ReporteSeguimientoWhatsApp = React.lazy(() => import('./Pages/Dashboard/WhatsApp/Reporteria/ReporteSeguimiento'));
const Bloqueos = React.lazy(() => import('./Pages/Dashboard/WhatsApp/Bloqueos/Index'));
const BibliotecaPlantillas = React.lazy(() => import('./Pages/Dashboard/WhatsApp/Plantillas/Index'));
const SesionesWhatsApp = React.lazy(() => import('./Pages/Dashboard/WhatsApp/SesionesBot/Index'))

const CapacitacionesPresenciales = React.lazy(() =>
  import("./Pages/Dashboard/CapacitacionesPresenciales/Index")
);
const CapacitacionPresencialListado = React.lazy(() =>
  import("./Pages/Dashboard/CapacitacionesPresenciales/Listado/Index")
);

export const RUTAS = {
  DASHBOARD: "/dashboard",
  ADMIN_HOME: "/admin-home",
  PRINCIPAL: "/principal",
  INGRESO: "/ingreso",
  REGISTRO: "/registro",
  OPCIONES: "/opciones",
  PERFIL: "/perfil",
  CONFIGURACION: "/configuracion",
  SEGMENTO_CRUD: "/segmento_crud",
  DISTRIBUCION: "/distribucion",
  ROL: "/rol",
  USUARIO: "/usuario",
  PERMISOS: "/permisos",
  DELEGACIONES: "/delegaciones",
  IDIOMA: "/idioma",
  PILARES: "/pilares",
  CURSOS: "/cursos",
  SUBPILAR: "/subpilar",
  PALABRAS_CLAVE: "/palabrasClave",
  NIVELES: "/niveles",
  CONTENIDO: "/contenido",
  CONTENIDO_HIJO: "/contenidoHijo",
  DIFICULTAD: "/dificultad",
  TIPOS_APRENDIZAJE: "/tiposAprendizaje",
  PAQUETES_CURSOS: "/paquetesCursos",
  SALA_CAPACITACION: "/salaCapacitacion",
  PARTICIPANTES: "/participantes",
  CAPACITACIONES: "/capacitaciones",
  CLIENTES: "/clientes",
  REPORTERIA: "/reporteria",
  SATISFACCION: "/satisfaccion",
  DETALLE_ACTA: "/detalleActa",
  REPORTE_AJUSTES: "/reporteAjustes",
  CASOS: "/casos",
  LIST_CASOS: "/listCasos",
  DETALLE_CASO: "/detalleCaso",
  CASOS_FORM: "/casosForm",
  SEGMENTO_EDUCATIVO: "/segmento_educativo",
  PRODUCTOS: "/productos",
  MICROAPRENDIZAJE: "/microaprendizaje",
  ESTRUCTURA: "/estructura",
  ENCUESTA: "/encuesta",
  CAMPANIA: "/campania",
  ADD_CAMPANIA: "/add_campania",
  CONTENIDO_MICROAPRENDIZAJE: "/contenidoMicroaprendizaje",
  HORARIO_CAMPANIAS: "/horarioCampanias",
  REPORTES_WHATSAPP: "/reportesWhatsApp",
  REPORTE_SEGUIMIENTO_WHATSAPP: "/reporteSeguimientoWhatsApp",
  BLOQUEO_CAMPANIAS: "/bloqueos",
  PLANTILLAS_WA: '/plantillas_wa',
  SESIONES_WA: '/sesiones_wa',
  TUTORIAL: "/tutorial",
  ADMIN_LOGIN: "/admin-login",
  MI_USUARIO: "/mi-usuario",
  MIS_CURSOS: "/mis-cursos",
  MIS_PAQUETES: "/mis-paquetes",
  MIS_FAVORITOS: "/mis-favoritos",
  MIS_CAPACITACIONES_PRESENCIALES: "/mis-capacitaciones-presenciales",
  CURSO_PATH: "/principal/curso/:idCurso",
  PAQUETE_PATH: "/principal/paquete/:idPaquete",
  PAQUETE_CURSO_PATH: "/principal/paquete/:idPaquete/curso/:idCurso",
  DIPLOMA_CURSO_PATH: "/principal/curso/:idCurso/diploma",
  DIPLOMA_PAQUETE_PATH: "/principal/paquete/:idPaquete/diploma",
  CURSO: (idCurso) => `/principal/curso/${idCurso}`,
  PAQUETE: (idPaquete) => `/principal/paquete/${idPaquete}`,
  PAQUETE_CURSO: (idPaquete, idCurso) =>
    `/principal/paquete/${idPaquete}/curso/${idCurso}`,
  DIPLOMA_CURSO: (idCurso) => `/principal/curso/${idCurso}/diploma`,
  DIPLOMA_PAQUETE: (idPaquete) => `/principal/paquete/${idPaquete}/diploma`,
  NOTIFICACIONES_PLANTILLAS: "/notificaciones-plantillas",
  NOTIFICACION_LISTA: "/notificaciones-lista",
  REFERIDOS: "/referidos",
  PREGUNTAS: "/preguntas",
  CAPACITACIONES_PRESENCIALES: "/capacitaciones-presenciales",
  CAPACITACION_PRESENCIAL_LISTADO: "/capacitacion-presencial-listado",
  ATENCION_CLIENTE: "/atencion-cliente",
  CURSOS_CLIENTE: "/cursos-cliente",
  PAQUETES_CLIENTE: "/paquetes-cliente",
};

export const clientRoutes = [
  RUTAS.PRINCIPAL,
  RUTAS.MIS_CURSOS,
  RUTAS.MIS_PAQUETES,
  RUTAS.MIS_FAVORITOS,
  RUTAS.MIS_CAPACITACIONES_PRESENCIALES,
  RUTAS.MI_USUARIO,
  RUTAS.CURSO_PATH,
  RUTAS.PAQUETE_PATH,
  RUTAS.PAQUETE_CURSO_PATH,
  RUTAS.DIPLOMA_CURSO_PATH,
  RUTAS.DIPLOMA_PAQUETE_PATH,
];

export const adminRoutes = [
  { path: RUTAS.DASHBOARD, element: Dashboard },
  { path: RUTAS.ADMIN_HOME, element: AdminHome },
  { path: RUTAS.INGRESO, element: Ingreso },
  { path: RUTAS.REGISTRO, element: Registro },
  { path: RUTAS.OPCIONES, element: Opciones },
  { path: RUTAS.PERFIL, element: Perfil },
  { path: RUTAS.SEGMENTO_CRUD, element: Segmento },
  { path: RUTAS.DISTRIBUCION, element: Distribucion },
  { path: RUTAS.ROL, element: Rol },
  { path: RUTAS.USUARIO, element: Usuarios },
  { path: RUTAS.PERMISOS, element: Permisos },
  { path: RUTAS.IDIOMA, element: Idiomas },
  { path: RUTAS.PILARES, element: Pilares },
  { path: RUTAS.CURSOS, element: Cursos },
  { path: RUTAS.SUBPILAR, element: Subpilares },
  { path: RUTAS.PALABRAS_CLAVE, element: PalabrasClave },
  { path: RUTAS.NIVELES, element: Niveles },
  { path: RUTAS.CONTENIDO, element: Contenido },
  { path: RUTAS.CONTENIDO_HIJO, element: ContenidoHijo },
  { path: RUTAS.DELEGACIONES, element: Delegaciones },
  { path: RUTAS.SALA_CAPACITACION, element: SalaCapacitacion },
  { path: RUTAS.REPORTERIA, element: ReporteCapacitaciones },
  { path: RUTAS.SATISFACCION, element: ReporteSatisfaccion },
  { path: RUTAS.PARTICIPANTES, element: RegistroParticipantes },
  { path: RUTAS.CAPACITACIONES, element: ListadoCapacitaciones },
  { path: RUTAS.CASOS, element: CasosEspeciales },
  { path: RUTAS.LIST_CASOS, element: ListadoCasos },
  { path: RUTAS.DETALLE_CASO, element: DetalleCaso },
  { path: RUTAS.CASOS_FORM, element: CasosForm },
  { path: RUTAS.DETALLE_ACTA, element: DetalleActa },
  { path: RUTAS.REPORTE_AJUSTES, element: ReporteAjustes },
  { path: RUTAS.CONFIGURACION, element: Configuracion },
  { path: RUTAS.CLIENTES, element: Clientes },
  { path: RUTAS.SEGMENTO_EDUCATIVO, element: SegmentosEducativos },
  { path: RUTAS.PRODUCTOS, element: Productos },
  { path: RUTAS.MICROAPRENDIZAJE, element: Microaprendizaje },
  { path: RUTAS.ESTRUCTURA, element: Estructura },
  { path: RUTAS.ENCUESTA, element: Encuesta },
  { path: RUTAS.CAMPANIA, element: Campania },
  { path: RUTAS.ADD_CAMPANIA, element: AgregarCampania },
  {
    path: RUTAS.CONTENIDO_MICROAPRENDIZAJE,
    element: ContenidoMicroaprendizaje,
  },
  { path: RUTAS.HORARIO_CAMPANIAS, element: HorarioCampanias },
  {path: RUTAS.REPORTES_WHATSAPP, element: ReportesWhatsApp},
  {path: RUTAS.REPORTE_SEGUIMIENTO_WHATSAPP, element: ReporteSeguimientoWhatsApp},
  {path: RUTAS.BLOQUEO_CAMPANIAS, element: Bloqueos},
  {path: RUTAS.PLANTILLAS_WA, element: BibliotecaPlantillas},
  {path: RUTAS.SESIONES_WA, element: SesionesWhatsApp},
  { path: RUTAS.DIFICULTAD, element: Dificultad },
  { path: RUTAS.TIPOS_APRENDIZAJE, element: TiposAprendizaje },
  { path: RUTAS.PAQUETES_CURSOS, element: PaquetesCursos },
  { path: RUTAS.TUTORIAL, element: Tutorial },
  { path: RUTAS.PREGUNTAS, element: Preguntas },
  { path: RUTAS.NOTIFICACIONES_PLANTILLAS, element: NotificacionesPlantillas },
  { path: RUTAS.NOTIFICACION_LISTA, element: NotificacionesLista },
  { path: RUTAS.REFERIDOS, element: ReferidosLista },
  { path: RUTAS.ATENCION_CLIENTE, element: AtencionCliente },
  {
    path: RUTAS.CAPACITACIONES_PRESENCIALES,
    element: CapacitacionesPresenciales,
  },
  {
    path: RUTAS.CAPACITACION_PRESENCIAL_LISTADO,
    element: CapacitacionPresencialListado,
  },
  { path: RUTAS.CURSOS_CLIENTE, element: CursosCliente },
  { path: RUTAS.PAQUETES_CLIENTE, element: PaquetesCliente },
];
